import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const DangerTriangleIcon: FC<Props> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.42645 8.96791C6.85841 4.65597 8.0744 2.5 10 2.5C11.9256 2.5 13.1416 4.65597 15.5736 8.96791L15.8766 9.50522C17.8976 13.0884 18.9081 14.88 17.9948 16.19C17.0815 17.5 14.8221 17.5 10.3031 17.5H9.69697C5.17799 17.5 2.9185 17.5 2.00523 16.19C1.09197 14.88 2.10245 13.0884 4.1234 9.50523L4.42645 8.96791Z"
        stroke={props.fill || "currentColor" || "#D22D3D"}
        strokeWidth="1.25"
      />
      <path
        d="M10 6.66675V10.8334"
        stroke={props.fill || "currentColor" || "#D22D3D"}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <circle
        cx="10"
        cy="13.3333"
        r="0.416667"
        stroke={props.fill || "currentColor" || "#D22D3D"}
        strokeWidth="0.833333"
      />
    </svg>
  );
};

export default DangerTriangleIcon;
